module.exports = __webpack_public_path__ + "static/media/people-using-computer@2x.5906689e.jpg";